<div class="mt-3 pb-4">

  <p *ngIf="!!timestamp" class="lead text-uppercase mb-1 fs-6">{{ timestamp_number | relativeDateCmsText:'si_pts_chrome_details_timestamp':timestamp | async }}</p>

  <h1 [ngClass]="{ 'placeholder': !result }" class="mb-3">{{header}}</h1>

    <p [appParagraph]="2" [ngClass]="{ 'placeholder': !result }" class="mb-5" [innerHtml]="text"></p>

    <div *ngIf="!result?.gamtest" class="row m-0">
      <a [routerLink]="'/dialogs/gamtest'" appStandardButton [ngClass]="{ 'placeholder': !result }">{{ 'si_pts_chrome_details_continue_link' | cmsText | async }}</a> <br />
    </div>
  @if (combinedLayout) {
  <!-- The recommendation is right below in the result card, so this opens the history instead -->
  <!-- A button, since it opens something on this page; a link would also open in a new tab without the session -->
  <button type="button" appLinkButton class="how-we-calculated-link" (click)="openHistory()" [ngClass]="{ 'placeholder': !result }">
    {{ 'si_pts_chrome_details_how_we_calculated_link' | cmsText | async }}
  </button>
  } @else {
  <a appStandardButton [routerLink]="['/dashboard']" fragment="recommendation-header" [ngClass]="{ 'placeholder': !result }">
    {{ 'si_pts_chrome_details_to_recommendations_link' | cmsText | async }}
  </a>
  }
</div>
